import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import LazySelect from "../../../../../../Components/CardsPages/Forms/LazySelect";
import SpinnerComponent from "../../../../../../Components/Loding/Spinner";
import { ListarCategoriaAtendimentoController } from "../../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import { ListarDocumentoTemplateController } from "../../../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    EditarAcaoEtapaController,
    GetAcaoReguaController,
    ListarReguaEtapaController,
    ListarTiposAcoesReguaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { IDocumentosTemplate } from "../../../../../../Interfaces/Geral/Documentos/DocumentosInterface";
import { ICategoriaAtendimento } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import {
    IAcoesReguaEtapa,
    ITipoAcaoRegua,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import { ACESSOS } from "../../../../../../Routes/Acessos";
import { ListarGruposController } from "../../../../../../Controllers/Geral/Grupos/GruposController";
import { GrupoInterface } from "../../../../../../Interfaces/Geral/Grupos/GrupoInterfaces";
import { ICadastrarAcaoEtapaBody } from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { ListarEquipesController } from "../../../../../../Controllers/HelpDesk/Equipes/EquipesControllers";
import { IEquipe } from "../../../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";

interface IProps {
    idAcaoEtapa: number;
    updateList: () => void;
    idEtapaRegua: number;
    setShow: (show: boolean) => void;
}

export default function ModalEditarAcoes(props: IProps) {
    const { IdRegua } = useParams<{ IdRegua: string }>();
    const [CategoriaAtendimento, setCategoriaAtendimento] =
        useState<Array<ICategoriaAtendimento>>();
    const [idCategoriaAtendimento, setIdCategoriaAtendimento] =
        useState<number>();
    const [LstTipoAcaoRegua, setLstTipoAcaoRegua] =
        useState<Array<ITipoAcaoRegua>>();
    const [lstEquipeHelpdesk, setLstEquipeHelpdesk] = useState<IEquipe[]>();

    const [LstGrupo, setLstGrupo] = useState<Array<GrupoInterface>>();

    const [LstTemplate, setLstTemplate] =
        useState<Array<IDocumentosTemplate>>();
    const [AcoesEtapaRegua, setAcoesEtapaRegua] = useState<IAcoesReguaEtapa>();
    const [idAcao, setIdAcao] = useState<number | undefined>(0);
    const [dsTipoAcao, setDsTipoAcao] = useState<string | undefined>("");

    const [idDocumento, setIdDocumento] = useState<number | undefined>(0);
    const [idGrupo, setIdGrupo] = useState<number | undefined>(0);
    const [idEquipeHelpdesk, setIdEquipeHelpdesk] = useState<
        number | undefined
    >(0);

    const { register, handleSubmit, formState, setValue } = useForm();

    const findGrup = LstGrupo?.find(
        (grupo) => grupo.ID_GRUPO === AcoesEtapaRegua?.ID_GRUPO_DISTRIBUICAO
    );

    const findCategoria = CategoriaAtendimento?.find(
        (categoria) =>
            categoria.ID_CATEGORIA_ATENDIMENTO ===
            AcoesEtapaRegua?.ID_CATEGORIA_ATENDIMENTO
    );

    const findTemplate = LstTemplate?.find(
        (template) => template.ID_DOCUMENTO_TEMPLATE === buscarTemplate()
    );

    const findEquipeHelpdesk = lstEquipeHelpdesk?.find(
        (equipe) =>
            equipe.ID_EQUIPE_HELP_DESK === AcoesEtapaRegua?.ID_EQUIPE_HELPDESK
    );

    useEffect(() => {
        GetAcaoReguaController(props.idAcaoEtapa).then((res) => {
            setAcoesEtapaRegua(res);
            setIdAcao(res.ID_TIPO_ACAO);
            setDsTipoAcao(res.DS_TIPO_ACAO);
        });
    }, [props.idAcaoEtapa, IdRegua]);

    useEffect(() => {
        setIdDocumento(findTemplate?.ID_DOCUMENTO_TEMPLATE);
    }, [findTemplate]);
    useEffect(() => {
        setIdCategoriaAtendimento(findCategoria?.ID_CATEGORIA_ATENDIMENTO);
    }, [findCategoria]);
    useEffect(() => {
        setIdGrupo(findGrup?.ID_GRUPO);
    }, [findGrup]);
    useEffect(() => {
        setIdEquipeHelpdesk(findEquipeHelpdesk?.ID_EQUIPE_HELP_DESK);
    }, [findEquipeHelpdesk]);

    useEffect(() => {
        ListarCategoriaAtendimentoController(
            ACESSOS.ATENDIMENTO.ID_MODULO
        ).then((res) => {
            setCategoriaAtendimento(res);
        });

        ListarTiposAcoesReguaController().then((res) => {
            setLstTipoAcaoRegua(res);
        });

        ListarGruposController().then((res) => {
            setLstGrupo(res);
        });

        ListarDocumentoTemplateController({
            FL_NAO_CARREGA_TEMPLATE: true,
        }).then((res) => {
            setLstTemplate(res);
        });
        ListarEquipesController().then((res) => {
            setLstEquipeHelpdesk(res);
        });
    }, []);

    const ListarReguaEtapa = useCallback(
        () => ListarReguaEtapaController(Number.parseInt(IdRegua)),
        [IdRegua]
    );

    const { execute: editarAcaoEtapa } = useAsyncCallback(
        EditarAcaoEtapaController
    );

    function handleFormSubmit(formData: ICadastrarAcaoEtapaBody) {
        getDocumentoTemplate(formData);
        editarAcaoEtapa({
            ...formData,
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO: props.idAcaoEtapa,
        }).then((res) => {
            props.setShow(false);
            props.updateList();
        });
    }

    function buscarTemplate() {
        if (
            AcoesEtapaRegua?.ID_TEMPLATE_SMS !== null &&
            AcoesEtapaRegua?.ID_TEMPLATE_SMS !== 0
        ) {
            return AcoesEtapaRegua?.ID_TEMPLATE_SMS;
        }
        if (
            AcoesEtapaRegua?.ID_TEMPLATE_EMAIL !== null &&
            AcoesEtapaRegua?.ID_TEMPLATE_EMAIL !== 0
        ) {
            return AcoesEtapaRegua?.ID_TEMPLATE_EMAIL;
        }
        if (
            AcoesEtapaRegua?.ID_TEMPLATE_DISTRIBUICAO !== null &&
            AcoesEtapaRegua?.ID_TEMPLATE_DISTRIBUICAO !== 0
        ) {
            return AcoesEtapaRegua?.ID_TEMPLATE_DISTRIBUICAO;
        }
        return 0;
    }

    function getDocumentoTemplate(formData: ICadastrarAcaoEtapaBody) {
        if (dsTipoAcao === "SMS" || dsTipoAcao === "SMS Parcelas Vencidas") {
            if (formData !== undefined) {
                formData.ID_TEMPLATE_SMS = idDocumento ?? 0;

                formData.ID_TEMPLATE_EMAIL = 0;
                formData.ID_TEMPLATE_DISTRIBUICAO = 0;
            }
        }
        if (
            dsTipoAcao === "Email" ||
            dsTipoAcao === "Email Parcelas Vencidas" ||
            dsTipoAcao === "Email Aniversario" ||
            dsTipoAcao === "Relacionamento com Cliente - Agendado"
        ) {
            if (formData !== undefined) {
                formData.ID_TEMPLATE_EMAIL = idDocumento ?? 0;

                formData.ID_TEMPLATE_SMS = 0;
                formData.ID_TEMPLATE_DISTRIBUICAO = 0;
            }
        }
        if (dsTipoAcao === "Distribuição") {
            if (formData !== undefined) {
                formData.ID_TEMPLATE_DISTRIBUICAO = idDocumento ?? 0;

                formData.ID_TEMPLATE_SMS = 0;
                formData.ID_TEMPLATE_EMAIL = 0;
            }
        }
        if (dsTipoAcao === "") {
            if (formData !== undefined) {
                formData.ID_TEMPLATE_SMS = 0;
                formData.ID_TEMPLATE_EMAIL = 0;
                formData.ID_TEMPLATE_DISTRIBUICAO = 0;
            }
        }
    }

    return AcoesEtapaRegua ? (
        <form
            onSubmit={handleSubmit(handleFormSubmit)}
            className="w-100 d-flex justify-content-between align-itens-center mb-3"
        >
            <div className="w-100 h-100">
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-1 col-md-6">
                        <h6>Nome Da Ação:</h6>
                        <input
                            type="text"
                            name="DS_NOME_ACAO"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.DS_ETAPA && "is-invalid"
                            }`}
                            defaultValue={AcoesEtapaRegua?.DS_NOME_ACAO}
                            ref={register({
                                required: "Insira o nome da etapa",
                            })}
                        />
                    </div>
                    <div className="m-1 col-md-6">
                        <h6>Etapa:</h6>
                        <LazySelect
                            className="form-control"
                            name="ID_CASO_COBRANCA_REGUA_ETAPA"
                            ref={register({
                                required: "Insira uma etapa",
                            })}
                            defaultValue={
                                AcoesEtapaRegua?.ID_CASO_COBRANCA_REGUA_ETAPA
                            }
                            setValue={setValue}
                            controller={ListarReguaEtapa}
                            getDS={(re) => re.DS_NOME_ETAPA}
                            getKeyValue={(re) =>
                                re.ID_CASO_COBRANCA_REGUA_ETAPA
                            }
                        />
                    </div>
                </div>
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-1 col-md-6">
                        <h6>Template Documento:</h6>
                        <select
                            className="form-control"
                            name="ID_DOCUMENTO_TEMPLATE"
                            ref={register()}
                            value={idDocumento}
                            onChange={(e) =>
                                setIdDocumento(Number(e.target.value))
                            }
                        >
                            <option></option>
                            {LstTemplate &&
                                LstTemplate.map((template) => {
                                    return (
                                        <option
                                            key={template.ID_DOCUMENTO_TEMPLATE}
                                            value={
                                                template.ID_DOCUMENTO_TEMPLATE
                                            }
                                        >
                                            {template.DS_DOCUMENTO}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="m-1 col-md-6">
                        <h6>Tipo Ação:</h6>
                        <select
                            className="form-control"
                            name="ID_TIPO_ACAO"
                            ref={register()}
                            value={idAcao}
                            onChange={(e) => {
                                const index = Number(e.target.value);
                                const tipoAcaoString = LstTipoAcaoRegua?.filter(
                                    (x) =>
                                        x.ID_CASO_COBRANCA_REGUA_TIPO_ACAO ===
                                        index
                                )[0].DS_TIPO_ACAO;
                                setDsTipoAcao(tipoAcaoString);

                                setIdAcao(Number(e.target.value));
                            }}
                        >
                            {LstTipoAcaoRegua &&
                                LstTipoAcaoRegua.map((tipoAcao) => {
                                    return (
                                        <option
                                            key={
                                                tipoAcao.ID_CASO_COBRANCA_REGUA_TIPO_ACAO
                                            }
                                            value={
                                                tipoAcao.ID_CASO_COBRANCA_REGUA_TIPO_ACAO
                                            }
                                        >
                                            {tipoAcao.DS_TIPO_ACAO}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>
                <div className="d-flex flew-wrap col-md-12">
                    <div className="m-1 col-md-6">
                        <h6>Categoria Atendimento:</h6>
                        <select
                            className="form-control"
                            name="ID_CATEGORIA_ATENDIMENTO"
                            ref={register()}
                            value={idCategoriaAtendimento}
                            onChange={(e) =>
                                setIdCategoriaAtendimento(
                                    Number(e.target.value)
                                )
                            }
                        >
                            <option></option>
                            {CategoriaAtendimento &&
                                CategoriaAtendimento.map((categ) => {
                                    return (
                                        <option
                                            key={categ.ID_CATEGORIA_ATENDIMENTO}
                                            value={
                                                categ.ID_CATEGORIA_ATENDIMENTO
                                            }
                                        >
                                            {categ.DS_CATEGORIA_ATENDIMENTO}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="m-1 col-md-6">
                        <h6>Equipe de atendimento</h6>
                        <select
                            name="ID_EQUIPE_HELPDESK"
                            className="form-control"
                            ref={register()}
                            value={idEquipeHelpdesk}
                            onChange={(e) =>
                                setIdEquipeHelpdesk(Number(e.target.value))
                            }
                        >
                            <option></option>
                            {lstEquipeHelpdesk &&
                                lstEquipeHelpdesk.map((lstEquipe) => {
                                    return (
                                        <option
                                            key={lstEquipe.ID_EQUIPE_HELP_DESK}
                                            value={
                                                lstEquipe.ID_EQUIPE_HELP_DESK
                                            }
                                        >
                                            {lstEquipe.DS_EQUIPE_HELP_DESK}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>

                <div className="d-flex flew-wrap col-md-12">
                    {idAcao === 3 ? (
                        <div className="m-1 col-md-6">
                            <h6>Grupo:</h6>
                            <select
                                className="form-control"
                                name="ID_GRUPO_DISTRIBUICAO"
                                ref={register()}
                                value={idGrupo}
                                onChange={(e) =>
                                    setIdGrupo(Number(e.target.value))
                                }
                            >
                                {LstGrupo &&
                                    LstGrupo.map((grupo) => {
                                        return (
                                            <option
                                                key={grupo.ID_GRUPO}
                                                value={grupo.ID_GRUPO}
                                            >
                                                {grupo.DS_GRUPO}
                                            </option>
                                        );
                                    })}
                            </select>
                        </div>
                    ) : null}
                </div>

                <div className="d-flex justify-content-end mr-4">
                    <button className="btn btn-outline-primary font-weight-bold d-flex justify-content-center align-items-center">
                        <FontAwesomeIcon
                            icon={faEdit}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Editar
                    </button>
                </div>
            </div>
        </form>
    ) : (
        <SpinnerComponent />
    );
}
